import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { dbNamesOf, SqlDatabase } from "remult";
import { VolunteerOrganization } from "./entity";

const createCustomFilter =
  createCustomFilterForEntity<VolunteerOrganization>();

export class VolunteerOrganizationFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<VolunteerOrganization>
  >((filters) =>
    filterWithRelationsAndJson(VolunteerOrganization)(filters),
  );

  static get dbNames() {
    return dbNamesOf(VolunteerOrganization, {
      tableName: true,
    });
  }

  static isAddressInRadiusFromPoint = createCustomFilter<{
    lat: number;
    lng: number;
    radius: {
      distance: number;
      measure: "km" | "m";
    };
  }>((coordinates) => {
    return SqlDatabase.rawFilter(async (build) => {
      const {
        lat,
        lng,
        radius: { distance, measure },
      } = coordinates;

      const dbNames = await this.dbNames;
      const radiusMeters = measure === "km" ? distance * 1000 : distance;
      const searchPoint = `ST_SetSRID(ST_MakePoint(${build.param(lng)}, ${build.param(lat)}), 4326)::geography`;
      const jsonPoint = (alias: string) =>
        `ST_SetSRID(ST_MakePoint((${alias}->>'lng')::float, (${alias}->>'lat')::float), 4326)::geography`;
      const jsonHasPoint = (alias: string) =>
        `${alias} IS NOT NULL AND (${alias}->>'lat') ~ '^-?[0-9]+(\\.[0-9]+)?$' AND (${alias}->>'lng') ~ '^-?[0-9]+(\\.[0-9]+)?$'`;

      build.sql = `
      (
        (${build.param(lat)}::float = 0 AND ${build.param(lng)}::float = 0)
        OR (
          ${jsonHasPoint(String(dbNames.coordinates))}
          AND ST_DWithin(
            ${jsonPoint(String(dbNames.coordinates))},
            ${searchPoint},
            ${build.param(radiusMeters)}
          )
        )
      )
    `;
    });
  });
}
